import { render, staticRenderFns } from "./__BillingHistory.vue?vue&type=template&id=2aa79d7b"
import script from "./__BillingHistory.vue?vue&type=script&lang=js"
export * from "./__BillingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports